// src/components/servicepartner/ServicePartnerInfoForm.jsx
import { useState, useEffect } from "react";
import axios from "axios";
export default function ServicePartnerInfoForm({ partnerInfo, setPartnerInfo }) {
const [herstellerList, setHerstellerList] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/hersteller`)
      .then((res) => setHerstellerList(res.data))
      .catch((err) => console.error("Error loading Hersteller:", err));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPartnerInfo((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  return (
    <div style={{ marginTop: "30px" }}>
      <h3>Allgemeine Informationen</h3>

      {/* Basic yes/no */}
      <label>
        <input
          type="checkbox"
          name="eigeneAnlagen"
          checked={partnerInfo.eigeneAnlagen || false}
          onChange={handleChange}
        />
        Haben Sie eigene PV-Anlagen gebaut?
      </label>
      <br />

      <label>
        <input
          type="checkbox"
          name="betreuenPvAnlagen"
          checked={partnerInfo.betreuenPvAnlagen || false}
          onChange={handleChange}
        />
        Betreuen Sie bereits PV-Anlagen?
      </label>
      <br />

      <label>
        <input
          type="checkbox"
          name="monitoringErfahrung"
          checked={partnerInfo.monitoringErfahrung || false}
          onChange={handleChange}
        />
        Erfahrung im Monitoring?
      </label>

      <hr />

      {/* Radius */}
      <label>
        <input
          type="checkbox"
          name="einsatzradius100km"
          checked={partnerInfo.einsatzradius100km || false}
          onChange={handleChange}
        />
        Können Sie 100 km Radius abdecken?
      </label>
      <br />

      Nein, bis max.:
      <input
        type="number"
        name="einsatzradiusNeinKm"
        value={partnerInfo.einsatzradiusNeinKm || ""}
        onChange={handleChange}
        style={{
          width: "80px",
          marginLeft: "5px",
          border: "1px solid #000",
          padding: "2px 4px"
        }}
      />

      <br />

      Größerer Radius möglich — bis max.:
      <input
        type="number"
        name="grosserRadiusKm"
        value={partnerInfo.grosserRadiusKm || ""}
        onChange={handleChange}
        style={{
          width: "80px",
          marginLeft: "5px",
          border: "1px solid #000",
          padding: "2px 4px"
        }}
      />

      <hr />

      {/* Lehrgänge */}
  <div>
  <label>
    <input
      type="checkbox"
      name="lehrgangWechselrichter"
      checked={partnerInfo.lehrgangWechselrichter || false}
      onChange={handleChange}
    />
    Lehrgang Wechselrichter?
  </label>

  <select
    name="herstellerWechselrichter"
    value={partnerInfo.herstellerWechselrichter || ""}
    onChange={handleChange}
    style={{ marginLeft: "10px" }}
  >
    <option value="">Hersteller wählen</option>
    {herstellerList
      .filter((h) => h.wechselrichter)
      .map((h) => (
        <option key={h.id} value={h.name}>
          {h.name}
        </option>
      ))}
  </select>
</div>

<div>
  <label>
    <input
      type="checkbox"
      name="lehrgangSpeicher"
      checked={partnerInfo.lehrgangSpeicher || false}
      onChange={handleChange}
    />
    Lehrgang Energiespeicher?
  </label>

  <select
    name="herstellerSpeicher"
    value={partnerInfo.herstellerSpeicher || ""}
    onChange={handleChange}
    style={{ marginLeft: "10px" }}
  >
    <option value="">Hersteller wählen</option>
    {herstellerList
      .filter((h) => h.energiespeicher)
      .map((h) => (
        <option key={h.id} value={h.name}>
          {h.name}
        </option>
      ))}
  </select>
</div>

<div>
  <label>
    <input
      type="checkbox"
      name="lehrgangDatenlogger"
      checked={partnerInfo.lehrgangDatenlogger || false}
      onChange={handleChange}
    />
    Lehrgang Datenlogger?
  </label>

  <select
    name="herstellerDatenlogger"
    value={partnerInfo.herstellerDatenlogger || ""}
    onChange={handleChange}
    style={{ marginLeft: "10px" }}
  >
    <option value="">Hersteller wählen</option>
    {herstellerList
      .filter((h) => h.datenlogger)
      .map((h) => (
        <option key={h.id} value={h.name}>
          {h.name}
        </option>
      ))}
  </select>
</div>

      <hr />

      <label style={{ display: "block" }}>
        <input
          type="checkbox"
          name="fernwirktechnikErfahrung"
          checked={partnerInfo.fernwirktechnikErfahrung || false}
          onChange={handleChange}
        />
        Haben Sie Erfahrung mit dem Einbau von Fernwirktechnik?
        (Einspeisemanagement, Funkrundsteuerempfänger, Direktvermarkterschnittstelle, etc.)
      </label>


      <label style={{ display: "block" }}>
        <input
          type="checkbox"
          name="konzession"
          checked={partnerInfo.konzession || false}
          onChange={handleChange}
        />
        Haben Sie eine Konzession von einem Stromnetzbetreiber? Wenn ja, von welchem
      </label>


      <label style={{ display: "block" }}>
        <input
          type="checkbox"
          name="zaehler"
          checked={partnerInfo.zaehler || false}
          onChange={handleChange}
        />
        Können Sie Zähler-Register auslesen?
      </label>


      <hr />



      {/* Normen */}
      <h4>Normen</h4>
      {[
        "vde100_100",
        "vde0105_100",
        "vde126_23",
        "vde100_410",
        "vde100_600",
        "vde100_712",
        "vde105_305_3",
        "pvCheck",
      ].map((n) => (
        <label key={n} style={{ display: "block" }}>
          <input
            type="checkbox"
            name={n}
            checked={partnerInfo[n] || false}
            onChange={handleChange}
          />
          {n}
        </label>
      ))}

      <hr />

      {/* Qualifikation */}
      <h4>Qualifikation</h4>

      {["solateurLSG", "solateurFrei", "solateurHK", "solateurIHK", "solateurTUEV"].map(
        (q) => (
          <label key={q} style={{ display: "block" }}>
            <input
              type="checkbox"
              name={q}
              checked={partnerInfo[q] || false}
              onChange={handleChange}
            />
            {q}
          </label>
        )
      )}
    </div>
  );
}